import { render, staticRenderFns } from "./OrderPreview.vue?vue&type=template&id=3920dc3e&scoped=true"
import script from "./OrderPreview.vue?vue&type=script&lang=js"
export * from "./OrderPreview.vue?vue&type=script&lang=js"
import style0 from "./OrderPreview.vue?vue&type=style&index=0&id=3920dc3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3920dc3e",
  null
  
)

export default component.exports